export default function Loader() {
  return (
    <div className="w-100 h-100 position-fixed top-0 right- bottom-0 left-0 bg-white z-3 d-flex flex-column justify-content-center align-items-center" style={{opacity: 0.85}}>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )
}